import React from 'react';
import myPic from '../../images/myporfile.jpg'

const About = () => {
    return (
        <div>
            <h1 className='text-center text-4xl font-bold'>About Me</h1>
            <div class="hero min-h-screen">
                <div class="hero-content flex-col lg:flex-row">
                    <img src={myPic} class="max-w-sm rounded-lg shadow-2xl" />
                    <div className="card-body ml-6">
                        <p className="card-title">Full stack web developer with background knowledge of MERN stacks with react.</p>
                        <h1 className='text-xl'>
                            Here are a Few Highlights:
                        </h1>
                        <ul className="list-disc list-outside text-xl">
                            <li>Full Stack web development</li>
                            <li>Interactive Front End as per the design</li>
                            <li>React and React Router</li>
                            <li>Building REST API</li>
                            <li>Managing database</li>

                        </ul>

                        <div className="card-actions justify-end">
                            <a href="https://drive.google.com/u/0/uc?id=141ANVixo0cOZGijP22UDySvupd2bT_nW&export=download" download="MD.NAZMUL MD-NAZMUL.pdf">
                                <button className="btn btn-outline">Get Resume</button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;